<template>
  <div>
    <form class="form" ref="ban_user_request">
      <!--begin::Card-->
      <div class="card card-custom">
        <!--begin::Header-->
        <div class="card-header py-3">
          <div class="card-title">
            <h3 class="card-label font-weight-bolder text-dark">
              مسدود کردن کاربر
            </h3>
          </div>
          <div class="card-toolbar">
            <button
              type="button"
              class="btn btn-sm btn-primary mr-2"
              @click="request()"
              ref="ban_user_btn"
            >
              تایید
            </button>
          </div>
        </div>
        <!--end::Header-->
        <div class="card-body">
          <div>
            <div class="form-group row">
              <label class="col-xl-3 col-lg-3 col-form-label text-alert">
                تاریخ
              </label>
              <div class="col-lg-9 col-xl-6">
                <b-col>
                  <date-picker
                    type="datetime"
                    v-model="until"
                    name="start"
                    format="YYYY/MM/DD HH:mm:ss"
                    display-format="HH:mm jYYYY/jMM/jDD"
                    color="#4554a0"
                    label="تا تاریخ"
                    class="date-picker-style"
                  />
                </b-col>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<style>
.vpd-icon-btn {
  margin-bottom: 0;
}
</style>
<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { mapGetters } from "vuex";
import { BAN_USER_ADMIN } from "@/core/services/store/admin/users.module.js";
import { BAN_USER_COMPANY } from "@/core/services/store/company/users.module.js";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "BlockUser",
  props: ["value", "userId"],
  data() {
    return {
      off: "off",
      time: 0,
      timer: null,
      isCompany: this.$route.name.startsWith("company"),
      isAdmin: this.$route.name.startsWith("admin"),
      until: ""
    };
  },
  components: {
    datePicker: VuePersianDatetimePicker
  },
  mounted() {
    const ban_user_request = this.$refs["ban_user_request"];

    this.fv = formValidation(ban_user_request, {
      fields: {
        until: {
          validators: {
            notEmpty: {
              message: "تاریخ ضروری است."
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  methods: {
    request() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          const submitButton = this.$refs["ban_user_btn"];
          this.disableBtn(submitButton);
          this.$store
            .dispatch(this.isAdmin ? BAN_USER_ADMIN : BAN_USER_COMPANY, [
              this.userId,
              {
                until: this.until
              }
            ])
            .then(response => {
              this.time = response["expires_after"];
              this.startTimer();
              this.enableBtn(submitButton);
              this.showMessage("کاربر مسدود شد.");
              this.$emit("input", false);
              this.eventHub.$emit("re_render_page", this);
            })
            .catch(() => {
              this.enableBtn(submitButton);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به طور صحیح تکمیل نمایید");
        }
      });
    },

    startTimer() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.time > 0) {
            this.time--;
          } else {
            this.stopTimer();
          }
        }, 1000);
      }
    },
    stopTimer() {
      clearInterval(this.timer);
      this.timer = null;
      this.time = 0;
    }
  },
  computed: {
    ...mapGetters(["currentUserPersonalInfo"])
  }
};
</script>
